/* eslint-disable react/prop-types */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import Text from '../../../../shared/components/Text/Text';
import { setActiveModal, setSelectedReduxCalendar } from '../../ducks/calendarActions';
import usePreSaveNavigationGuard from '../../hooks/usePreSaveNavigationGuard';

const BreadCrumbsContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ParentBreadCrumb = styled('div')`
 cursor: pointer;
 &:hover {
    opacity: 0.7;
  }  
  
`;

const SubBreadCrumb = styled('div')`
cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
`;

const CurrentBreadCrumb = styled('div')`
`;

const BreadCrumbs = () => {
  const dispatch = useDispatch();
  const guardNavigation = usePreSaveNavigationGuard();
  const programType = useSelector((state) => state.calendar.data.programType);
  const selectedReduxNonDateBasedProgram = useSelector(
    (state) => state.calendar.data.selectedReduxNonDateBasedProgram,
  );
  const selectedCalendar = useSelector((state) => state.calendar.data.selectedReduxCalendar);
  const selectedReduxAthlete = useSelector((state) => state.calendar.data.selectedReduxAthlete);
  const parentCalendars = useSelector((state) => state.calendar.data.parentCalendars);

  // Check if the selected calendar has parent information
  const hasParentCalendar = selectedCalendar?.parentCalendarInfo
    && Object.keys(selectedCalendar.parentCalendarInfo).length > 0;

  const calendarNameWriter = () => {
    if (Object.keys(selectedCalendar).length) {
      return selectedCalendar?.name ? `${selectedCalendar?.name}` : 'Select Calendar';
    }
    if (Object.keys(selectedReduxAthlete).length) {
      return selectedReduxAthlete?.first && selectedReduxAthlete?.last ? `${selectedReduxAthlete?.first} ${selectedReduxAthlete?.last}` : 'Select Calendar';
    }
    return 'Select Calendar';
  };

  const programLibraryNameWriter = () => {
    if (Object.keys(selectedReduxNonDateBasedProgram).length) {
      return selectedReduxNonDateBasedProgram?.programName ? `${selectedReduxNonDateBasedProgram?.programName}` : 'Select Program';
    }
    return 'Select Program';
  };

  const isCalendarSelected = Object.keys(selectedCalendar).length > 0
    || (Object.keys(selectedReduxAthlete).length > 0
      && selectedReduxAthlete?.first
      && selectedReduxAthlete?.last);

  const isProgramSelected = Object.keys(selectedReduxNonDateBasedProgram).length > 0;

  const handleParentClick = () => guardNavigation(() => {
    if (hasParentCalendar && parentCalendars) {
      // Find the parent calendar from the array of parentCalendars
      const parentCalendar = parentCalendars.find(
        (cal) => cal.id === selectedCalendar.parentCalendarInfo.id,
      );

      if (parentCalendar) {
        dispatch(setSelectedReduxCalendar(parentCalendar));
      }
    }
  });

  return (
    <BreadCrumbsContainer>
      <ParentBreadCrumb onClick={() => (dispatch(setActiveModal('selectCalendarModal')))}>
        {programType === 'free-form-program' ? (
          <Text
            fontWeight={700}
            fontSize='14px'
            color='#444444'
          >
            Programs
          </Text>
        ) : (
          <Text
            fontWeight={700}
            fontSize='14px'
            color='#444444'
          >
            Calendars
          </Text>
        )}
      </ParentBreadCrumb>

      {/* Parent Calendar Breadcrumb - Only shown for subcalendars */}
      {hasParentCalendar && programType === 'calendar' && (
        <>
          <Text style={{ transform: 'rotate(15deg)', paddingLeft: 5, paddingRight: 5 }} fontSize='16px' color='rgba(158, 158, 158, 1)'> / </Text>
          <SubBreadCrumb onClick={handleParentClick}>
            <Text
              fontWeight={700}
              fontSize='14px'
              color='#444444'
            >
              {selectedCalendar.parentCalendarInfo.name}
            </Text>
          </SubBreadCrumb>
        </>
      )}

      {/* Current Calendar Breadcrumb */}
      {isCalendarSelected && programType === 'calendar' && (
        <>
          <Text style={{ transform: 'rotate(15deg)', paddingLeft: 5, paddingRight: 5 }} fontSize='16px' color='rgba(158, 158, 158, 1)'> / </Text>
          <CurrentBreadCrumb>
            <Text fontSize='14px' color='rgba(158, 158, 158, 1)'>{calendarNameWriter()}</Text>
          </CurrentBreadCrumb>
        </>
      )}

      {/* Current Program Breadcrumb */}
      {isProgramSelected && programType === 'free-form-program' && (
        <>
          <Text style={{ transform: 'rotate(15deg)', paddingLeft: 5, paddingRight: 5 }} fontSize='16px' color='rgba(158, 158, 158, 1)'> / </Text>
          <CurrentBreadCrumb>
            <Text fontSize='14px' color='rgba(158, 158, 158, 1)'>{programLibraryNameWriter()}</Text>
          </CurrentBreadCrumb>
        </>
      )}
    </BreadCrumbsContainer>
  );
};

export default BreadCrumbs;
